import type { ImageWidget } from "~/types/widgets"

/**
 * @titleBy alt
 */
export interface Differential {
    /**
     * @title Imagem
     */
    image: ImageWidget

    /**
     * @title Texto alternativo da imagem
     */
    alt?: string

    /**
     * @title Texto
     * @format textarea
     */
    text: string
}

export interface Props {
    /**
     * @title Título
     */
    title?: string

    /**
     * @title Diferenciais
     */
    differentials: Differential[]

    /**
     * @title Mensagem inferior
     */
    message?: string

    /**
     * @title Imagem de fundo
     */
    backgroundImage?: ImageWidget
}

export default function Differentials({ title, differentials, message, backgroundImage }: Props) {
    if (!differentials?.length) return null

    return (
        <div
            className={backgroundImage
                ? 'bg-center bg-no-repeat bg-cover bg-fixed lg:bg-scroll'
                : 'bg-[#8a1538]'}
            style={{ backgroundImage: `url(${backgroundImage})` }}
        >
            <div className='bg-[#ff267b] bg-opacity-40'>
                <div className='max-w-[1810px] mx-auto py-12 font-lato grid justify-items-center gap-16'>
                    {title && (
                        <h2
                            className='text-white text-[48px] text-center font-black resale-lingerie-scale-animation'
                            dangerouslySetInnerHTML={{ __html: title }}
                        />
                    )}

                    <ul className='flex flex-wrap justify-center gap-14'>
                        {differentials.map((item) => (
                            <li className='max-w-[285px] grid justify-items-center gap-4'>
                                <p className='text-white text-[19px] text-center leading-7'>
                                    {item.text}
                                </p>

                                <img
                                    className='lg:mb-4 aspect-square object-contain'
                                    src={item.image}
                                    alt={item.alt}
                                    width={180}
                                    height={180}
                                    loading='lazy'
                                />
                            </li>
                        ))}
                    </ul>

                    {message && (
                        <strong className='max-w-[480px] text-white text-[26px] leading-9 text-center font-bold'>
                            {message}
                        </strong>
                    )}
                </div>
            </div>
        </div>
    )
}
